export default __webpack_public_path__ + "static/media/IMG_1152 - Ashish Philip.82043f8b.jpg";